<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <resource-index header="Voting Goals" endpoint="voting-goals" show-route="voting-goals.view" />
            </div>
        </div>
    </div>
</template>

<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
    name: 'voting-goals',
    components: { ResourceIndex },
    computed: {
        userRole() {
            return this.$store.state.userRole
        }
    },
}
</script>
